import cx from 'classnames'
import React from 'react'

export const Input = ({
  className,
  ...other
}: React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>) => {
  return (
    <input
      className={cx(
        'bg-input-background border-solid border border-input-border text-french-blue-base text-base leading-6 text-base rounded-lg outline-none block w-full px-4 py-3 placeholder:text-input-placeholder placeholder:text-base placeholder:leading-6 hover:border-gray-3 focus:border-theme',
        className
      )}
      {...other}
    />
  )
}
